import { render, staticRenderFns } from "./ButtonsMap.vue?vue&type=template&id=24834443&scoped=true"
import script from "./ButtonsMap.vue?vue&type=script&lang=js"
export * from "./ButtonsMap.vue?vue&type=script&lang=js"
import style0 from "./ButtonsMap.vue?vue&type=style&index=0&id=24834443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24834443",
  null
  
)

export default component.exports